import { CircuitBreakerRetrievalApi, CircuitBreakerApi } from "./api";

export const GetCircuitBreakerStatus = async (
    service: string,
): Promise<any> => {
    const api = await CircuitBreakerRetrievalApi();
    const apiResponse = await api
        .get(`service/${service}`)
        .then((result) => {
            return result.data;
        });

    return apiResponse;
};


export const DisableCircuitBreaker = async (
    service: string,
): Promise<any> => {
    const api = await CircuitBreakerApi();
    const apiResponse = await api
        .post(`service/${service}/disable`)
        .then((result) => {
            return result.data;
        });

    return apiResponse;
};


export const EnableCircuitBreaker = async (
    service: string,
): Promise<any> => {
    const api = await CircuitBreakerApi();
    const apiResponse = await api
        .post(`service/${service}/enable`)
        .then((result) => {
            return result.data;
        });

    return apiResponse;
};